<template>
    <div>
        <div class="progress-bar" v-if="progressBar"><span :style="{'width': progressBar+'%'}"></span></div>

        <div class="progress-bar__text" v-if="progressBar"><span v-t="'Uploading...'"></span> {{progressBar}}%</div>

        <div>
            <div class="file-preview" v-if="model&&!progressBar">Currently: <a :href="model.file" target="_blank">{{model.file}}</a></div>

            <div class="tools" v-if="model&&!progressBar">
                <div class="replace-links">
                  <a class="replace-link" @click="removeFile()" v-t="'Remove File?'"></a>
                  <a class="replace-link" onclick="this.parentElement.parentElement.parentElement.getElementsByClassName('file')[0].click()" v-t="'Change File?'"></a>
                </div>
            </div>

            <input style="display:none" type="file" class="file" ref="files" @change="uploadFile($event.target.files)">

            <div class="field--file__img" v-if="!model&&!progressBar">
                <Droppable @upload="dropFile" class="file-area" onclick="this.parentElement.parentElement.getElementsByClassName('file')[0].click()">
                    <h3>{{title}}</h3>
                    <span v-t="'Click or Drag and Drop a PDF less than 10Mb'"></span>
                    <h3 class="on-hover" v-t="'Drop to Upload'"></h3>
                    <span class="on-hover" v-t="'PDF less than 10Mb'"></span>
                </Droppable>
            </div>
        </div>
    </div>
</template>

<script>
    import Droppable from '@/components/Droppable.vue'
    import fileService from '@/services/fileService.js'

    export default {
        props: ['model', 'title', 'cv'],
        components: {
            Droppable,
        },
        data () {
            return {
                progressBar: false,
            }
        },
        methods: {
            removeFile () {
              if(window.confirm("Are you sure you want to remove this file?")){
                this.$emit('remove');
              }
            },
            dropFile (file){
                if (file){
                    if (!file.name.match(/\.(pdf|PDF)$/)) {
                        window.alert('You must choose a PDF file.');
                    } else if( (file.size / 1024 / 1024) > 10){
                        window.alert('The maximum file size is 10Mb, try compressing your file.');
                    } else {
                        this.progressBar = 1;
                        var self = this
                        fileService.uploadFile(file,  function(progress){
                            self.progressBar = progress;
                        }, function(data){
                            self.$emit('changed', data)
                            self.progressBar = false;
                        }, this.cv);
                    }
                }
            },
            uploadFile(files){
                var file = files[0]
                this.dropFile(file)
            }
        }
    }
</script>
